import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const hasRulesIndicator = defineMessage({
	id: 'accessible-workflow-diagram.common.rules-indicator.has-rules-indicator',
	defaultMessage: 'Has {rulesCount, plural, one {# rule} other {# rules}}.',
	description: 'Indicates that a transition has rules',
});

const RulesIndicator = ({ rulesCount }: { rulesCount: number }): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	if (rulesCount <= 0) return null;

	return (
		<Text>
			{formatMessage(hasRulesIndicator, {
				rulesCount,
			})}
		</Text>
	);
};

export default RulesIndicator;
